import { render, staticRenderFns } from "./ClarificationText.vue?vue&type=template&id=04adf011&scoped=true"
import script from "./ClarificationText.vue?vue&type=script&lang=js"
export * from "./ClarificationText.vue?vue&type=script&lang=js"
import style0 from "./ClarificationText.vue?vue&type=style&index=0&id=04adf011&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04adf011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/src/Web/InternetBranch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04adf011')) {
      api.createRecord('04adf011', component.options)
    } else {
      api.reload('04adf011', component.options)
    }
    module.hot.accept("./ClarificationText.vue?vue&type=template&id=04adf011&scoped=true", function () {
      api.rerender('04adf011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClarificationText.vue"
export default component.exports